import Row from '@components/Row';
import Text from '@components/Text';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import MapPin from '@icons/MapPin';
import useCalculatedCart from '@store/cart/hooks/useCalculatedCart';
import { useTranslation } from 'react-i18next';

function ShopLocation() {
    const { shopName } = useCalculatedCart();
    const { t } = useTranslation('cart');
    return (
        <Container spacing={4} align='center'>
            <MapPin color={colors.gray6}/>
            <Row>
                <TextUnderline>
                    <Text size='lg' fontWeight='bold'>{shopName}</Text>
                </TextUnderline>
                <Text size='lg'>
                    {t('shopLocation.orderFrom')}
                </Text>
            </Row>
        </Container>
    );
}

const Container = styled(Row)`
    padding: 12px 16px;
    margin-top: 12px;
`;

export default ShopLocation;
